import { fetchApi, MONITORING_API } from '@/api/client'
import type {
  QuarantineGroupsResponse,
  QuarantineSample,
  QuarantineSummaryResponse,
} from '../types'

const BASE = `${MONITORING_API}/non-unifiable`

function qs(params: Record<string, string | number | undefined | null>): string {
  const q = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && v !== 'ALL') q.set(k, String(v))
  })
  const s = q.toString()
  return s ? `?${s}` : ''
}

export async function getQuarantineSummary(params: {
  from?: string
  to?: string
  stage?: string
  outcome?: string
  connector?: string
}): Promise<QuarantineSummaryResponse> {
  return fetchApi<QuarantineSummaryResponse>(`${BASE}/summary${qs(params)}`)
}

export async function getQuarantineGroups(params: {
  from?: string
  to?: string
  stage?: string
  outcome?: string
  accId?: string
  reason?: string
  eventType?: string
  connector?: string
  page?: number
  size?: number
  sort?: string
}): Promise<QuarantineGroupsResponse> {
  return fetchApi<QuarantineGroupsResponse>(`${BASE}/groups${qs(params)}`)
}

export async function getQuarantineSamples(params: {
  stage?: string
  outcome?: string
  reason?: string
  accId?: string
  eventType?: string
  connector?: string | null
  from?: string
  to?: string
  page?: number
  size?: number
}): Promise<QuarantineSample[]> {
  return fetchApi<QuarantineSample[]>(`${BASE}/samples${qs(params)}`)
}
